import BasePage from '../../../../../components/table_page';
import request from '../../../../../utils/request';
import hxForm from './hxform/index.js';
import dhForm from './dhform/index.js';

export default {
  name: 'banquet_zj_details',
  extends: BasePage,
  data() {
    return {
      params: {
        awardType: 'product',
      },
    };
  },
  components: {
    hxForm,
    dhForm,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    clickVisible({ row, val: { code } }) {
      const { isAudit, auditApproveStatus, logisticsNo } = row;
      if (code === 'fqhx' && isAudit === '1' && auditApproveStatus !== '1' && auditApproveStatus !== '2') {
        return true;
      }
      if (code === 'txdh' && isAudit === '0' && !logisticsNo) {
        return true;
      }
      return false;
    },
    modalClick({ val, row }) {
      console.log('val', val);
      if (val.code === 'fqhx' || val.code === 'view') {
        this.formName = 'hxForm';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '发起核销';
        this.openFull();
      }
      if (val.code === 'txdh') {
        this.formName = 'dhForm';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '填写单号';
        this.openModal();
      }
    },
  },
};
